import { render, staticRenderFns } from "./SearchTransactons.vue?vue&type=template&id=2466df35&scoped=true&"
import script from "./SearchTransactons.vue?vue&type=script&lang=js&"
export * from "./SearchTransactons.vue?vue&type=script&lang=js&"
import style0 from "./SearchTransactons.vue?vue&type=style&index=0&id=2466df35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466df35",
  null
  
)

export default component.exports